import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import * as moment from 'moment';
import * as cashFlow from './cash-flow.actions';
import { concat, EMPTY, Observable, of } from 'rxjs';
import { CashFlow, CashFlowRequest } from './cash-flow.models';
import { from } from 'rxjs/internal/observable/from';
import { HttpService } from '../../global/http.service';

import { downloadFile } from '../../global/fileDownload';
import { DatesInterval, DatesIntervalRequest } from '../../global/interfaces';
import { ToastService } from '../../shared/toaster_/toaster_.service';
import { Actions as ActionsCDK } from "atlas-cdk";

@Injectable()
export class CashFlowEffects {


  public loadCashFlowDates$ = createEffect(() => this.actions$.pipe(
    ofType<cashFlow.LoadCashDatesAction>(cashFlow.ActionTypes.LOAD_CASH_DATES),
    map(action => action.payload),
    switchMap(payload =>
      this.loadCashFlowDates(payload).pipe(
        map((response: DatesInterval) =>
          new cashFlow.LoadCashDatesSuccessAction(response)
        ),
        catchError(error =>
          // from([
          //   new cashFlow.LoadCashDatesFailedAction(error),
          //   new AddErrorToastAction(error.error.message)
          //   //this._toasterService.launchAlertError(error.error.message, Actions.error)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
          //   return of(new cashFlow.LoadCashDatesFailedAction(error));
          // }
          concat(
            of(new cashFlow.LoadCashDatesFailedAction(error)),
            of(null).pipe(
              tap(() => {
                this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  public loadCashFlow$ = createEffect(() => this.actions$.pipe(
    ofType<cashFlow.LoadCashDataAction>(cashFlow.ActionTypes.LOAD_CASH_DATA),
    map(action => action.payload),
    switchMap(payload =>
      this.loadCashFlow(payload).pipe(
        map((response: CashFlow[]) =>
          new cashFlow.LoadCashDataSuccessAction(response)
        ),
        catchError(error =>
          // from([
          //   new cashFlow.LoadCashDataFailedAction(error),
          //   new AddErrorToastAction(error.error.message)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
          //   return of(new cashFlow.LoadCashDataFailedAction(error));
          // }
          concat(
            of(new cashFlow.LoadCashDataFailedAction(error)),
            of(null).pipe(
              tap(() => {
                this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  public fileDownload$ = createEffect(() => this.actions$.pipe(
    ofType<cashFlow.CashFlowFileDownloadAction>(cashFlow.ActionTypes.CASH_FLOW_FILE_DOWNLOAD),
    map(action => action.payload),
    switchMap(payload =>
      this.downloadCashFlowFile(payload).pipe(
        map((response: any) => {
          // deepcode ignore DOMXSS:internally created secure response
          downloadFile(response.body, '*/*', 'CashFlowSummaryExport.csv');
        }),
        catchError(() => {
          // from([
          //   new AddErrorToastAction('Download failed. Please try again later.')
          // ])

          this._toasterService.launchAlertError('Download failed. Please try again later.', ActionsCDK.error);
          return EMPTY
        }
        )
      )
    )
  ), { dispatch: false });

  public constructor(
    private readonly actions$: Actions,
    private readonly http: HttpService,
    private readonly _toasterService: ToastService
  ) {
  }

  private loadCashFlowDates(payload: DatesIntervalRequest): Observable<DatesInterval> {
    return this.http.get(`/metrics/${payload.account}/date-ranges/cash-flow`);
  }

  private loadCashFlow(payload: CashFlowRequest): Observable<CashFlow[]> {
    return this.http.post(`/cash-flows/accounts/${payload.id}`, {
      from: payload.from, to: payload.to,
      country: payload.country
    });
  }

  private downloadCashFlowFile(payload: CashFlowRequest): Observable<any> {
    return this.http.post(`/cash-flows/accounts/${payload.id}/export`, {
      from: payload.from,
      to: payload.to,
      period: payload.period,
      quarter: payload.quarter,
      userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
      country: payload.country
    }, {
      observe: 'response',
      responseType: 'blob'
    });
  }
}
